/* ============================================================
 * NorthRidge — custom JS on top of the Aurora theme.
 * Loaded after the compiled Vite bundle (see layout/theme.liquid).
 * ============================================================ */

/* === NorthRidge: free-shipping bar "unlocked" state ===
 * Aurora's cart free-shipping bar swaps only its message text when the
 * threshold is reached — it toggles no completion-state class. It does drive
 * --gsc-freeshipping-bar-percent on the progress-fill (dots) element, so we
 * watch that value and add .nr-free-shipping-achieved to the <free-shipping-bar>
 * once it hits 100%, letting northridge-custom.css flip the bar to solid coral.
 * ponytail: reads the percent Aurora already computes; no cart-total re-parse. */
(function () {
  'use strict';

  var ACHIEVED = 'nr-free-shipping-achieved';

  function sync(bar) {
    var dots = bar.querySelector('[data-free-shipping-progress-bar-dots]');
    if (!dots) return;
    var pct = parseFloat(dots.style.getPropertyValue('--gsc-freeshipping-bar-percent'));
    bar.classList.toggle(ACHIEVED, pct >= 100);
  }

  function attach(bar) {
    if (bar.dataset.nrObserved) return;
    bar.dataset.nrObserved = 'true';
    sync(bar);
    var dots = bar.querySelector('[data-free-shipping-progress-bar-dots]');
    if (!dots) return;
    new MutationObserver(function () { sync(bar); })
      .observe(dots, { attributes: true, attributeFilter: ['style'] });
  }

  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(attach);
  }

  function init() {
    scan();
    // The cart drawer/page re-renders the bar on every cart update — catch new nodes.
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
